import {visibilityFilter} from '../../../utils/VisibilityFilter';
import {RootState} from '../../../store';
import {Organization} from './types';

const key = 'organizations';

// FNP-948: records moved to React Query. Redux keeps SELECTION (per FNP-951)
// and VISIBILITY (page, limit, keyword, columns). These no longer read
// `state.organizations.records` - see the paging trap in the sibling tickets.

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilityStateSelector = (state: RootState) => {
    return state[key].visibility;
};

/**
 * Derives the paged/filtered view from records React Query already fetched.
 * Takes `items` as an argument - the store no longer holds records.
 */
export const selectVisibility = (
    visibility: {
        page: number,
        limit: number,
        keyword: string,
        visible: boolean,
        columns: string[]
    },
    items: Organization[],
) => {
    const {
        page,
        limit,
        keyword,
        visible,
        columns
    } = visibility;

    const visibleItems = visibilityFilter<Organization>(items, page, limit, keyword);

    // Count against the real fetched set, not a slice that is never populated.
    const visibleCount = keyword ? visibleItems.length : items.length;

    const totalPages = Math.ceil(visibleCount / limit);

    return {
        items,
        visibleItems,
        page,
        limit,
        keyword,
        visible,
        columns,
        visibleCount,
        totalPages,
    };
};
